import { render, staticRenderFns } from "./VTaskViewerModal.vue?vue&type=template&id=93662378&"
import script from "./VTaskViewerModal.vue?vue&type=script&lang=js&"
export * from "./VTaskViewerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports